import React from "react";
import { CheckBoxComp } from "../../../inputs/fields.component";

const MetricCheckboxGroup = props => {
  const {
    items,
    checkboxes,
    setCheckboxes,
    checkboxName,
    subclassDefined
  } = props;

  return (
    <div className="metric-radio-container">
      {items.map(item => (
        <CheckBoxComp
          key={item.id}
          id={item.id}
          label={item.label}
          onChange={e => setCheckboxes(e)}
          classDefined="react-check-label"
          subclassDefined={subclassDefined}
          checkboxProps={{
            name: checkboxName,
            checked: checkboxes.has(item.id) // For now, need to change for edit later
          }}
        />
      ))}
    </div>
  );
};

export default MetricCheckboxGroup;
